import { Tooltip } from 'antd';
import { useRef, useState } from 'react';
import { CopyOutlined } from '@ant-design/icons';

export type CopyToClipboardProps = {
  children?: React.ReactNode;
  text?: string;
  hasIcon?: boolean;
  copyTooltip?: Partial<{ before: React.ReactNode; after: React.ReactNode }>;
};

export const CopyToClipboard = ({
  children,
  text,
  hasIcon = true,
  copyTooltip,
}: CopyToClipboardProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isCopied, setIsCopied] = useState(false);

  const tooltip = {
    before: 'Copy',
    after: 'Copied!',
    ...(copyTooltip || {}),
  };

  const handleClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (text) {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } else {
      await navigator.clipboard.writeText(
        wrapperRef.current?.textContent || ''
      );
      setIsCopied(true);
    }
  };

  return (
    <Tooltip
      title={isCopied ? tooltip.after : tooltip.before}
      onOpenChange={() => {
        setIsCopied(false);
      }}
    >
      <div
        ref={wrapperRef}
        className="cursor-pointer flex items-center gap-1"
        onClick={handleClick}
      >
        {children || text}
        {hasIcon && <CopyOutlined />}
      </div>
    </Tooltip>
  );
};
